import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EndPointUrl } from './api.enum';
import {AppService} from "../../../../../core/services/app.service";

@Injectable({
  providedIn: 'root'
})

export class SuiviEiaService {
  constructor(private service: AppService) {
  }

  ExportAgents(data): Observable<any> {
    const url: string = (<string>EndPointUrl.EXPORT_AGENT);
    return this.service.postData(`${url}`, data);
  }

}
